import React from 'react';

interface DefaultTokenIconProps {
  className?: string;
  size?: number;
}

/**
 * Default token icon displayed when a token doesn't have a logo
 * Uses a custom SVG token placeholder
 * Source: https://app.safe.global/images/common/token-placeholder.svg
 */
export function DefaultTokenIcon({
  className = '',
  size = 24,
}: DefaultTokenIconProps): React.ReactElement {
  // The default SVG is 26x26, so we scale it to the desired size.
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
    >
      <g fill="none">
        <circle cx="13" cy="13" r="13" fill="#E8E7E6" />
        <path
          d="M12.98 4.091a.415.415 0 00-.314.172L6.56 12.855a.413.413 0 000 .474l6.106 8.59a.406.406 0 00.334.172.415.415 0 00.334-.172l6.106-8.59a.413.413 0 000-.474l-6.107-8.592a.414.414 0 00-.353-.172zM13 5.864l2.288 6.818h-4.577zm-1.217 1.053l-1.935 5.765H7.686zm2.433 0l4.097 5.765h-2.162zM7.686 13.5h2.161l1.935 5.763zm3.025 0h4.577L13 20.316zm5.44 0h2.161l-4.096 5.763z"
          fill="#B2B5B2"
        />
      </g>
    </svg>
  );
}
